/** Default max request body size: 10 MB */
export const DEFAULT_MAX_BODY_SIZE = 10 * 1024 * 1024;
